































































import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import ClassifiedService from '~/services/classified/ClassifiedService'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { CConfirmationModal },
  props: {
    inContextMenu: { type: Boolean, required: false, default: false },
    classified: { type: Object, required: true }
  },
  data() {
    return {
      showAdminConfirmModal: false,
      confirmAction: () => {},
      confirmText: '',
      adminButtonStates: null
    }
  },
  computed: {},
  mounted() {
    this.fetchAdminButtonStates()
  },
  methods: {
    getButtonVariant(state) {
      if (state) {
        return 'danger'
      }
      return 'success'
    },
    async fetchAdminButtonStates() {
      const classifiedService = this.$dep(ClassifiedService)

      const [userEnabled, classifiedEnabled] = await Promise.all([
        await classifiedService.getBanPromoUserState(this.classified.id),
        await classifiedService.getBanPromoClassifiedState(this.classified.id)
      ])

      this.adminButtonStates = { ...userEnabled, ...classifiedEnabled }
    },
    banPromoUserClicked() {
      this.confirmText = this.$t(
        'this action will disable the promotion functionality for this user, continue?'
      )

      if (this.inContextMenu) {
        this.confirmAction = () => {
          this.confirmAction = () => {}
          this.confirmText = ''
          this.$emit('ban-promo-user')
        }
        this.showAdminConfirmModal = true
      } else if (confirm(this.confirmText)) {
        this.$emit('ban-promo-user')
      }
    },
    banPromoClassifiedClicked() {
      this.confirmText = this.$t(
        'this action will disable the promotion functionality for this classified, continue?'
      )

      if (this.inContextMenu) {
        this.confirmAction = () => {
          this.confirmAction = () => {}
          this.confirmText = ''
          this.$emit('ban-promo-classified')
        }
        this.showAdminConfirmModal = true
      } else if (confirm(this.confirmText)) {
        this.$emit('ban-promo-classified')
      }
    },
    enablePromoClassifiedClicked() {
      this.$emit('enable-promo-classified')
    },
    enablePromoUserClicked() {
      this.$emit('enable-promo-user')
    }
  }
})
